import axios from 'axios'
import { API_ADDRESS } from 'config'

interface AccountDataResponse {
  access_token: string // eslint-disable-line
  username: string
  phonenumber: string
  userId: string
  role: string
  shortName: string
}

export const getAccountData = async (accessToken: string): Promise<AccountDataResponse> => {
  // Let get our details from local storage
  const data = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

  return data
}

export const doLogin = async (username: string, password: string): Promise<any> => {
  const url = `${API_ADDRESS}/auth/login`
  const { data } = await axios.post(url, {
    username: username.toLowerCase(),
    password,
  })

  return data
}
